import React, {useState} from 'react';
import '../config.js';
import Progress from '../components/progress.js';
import DefaultHeader from '../components/defaultHeader.js';
import img from '../assets/contact.jpg';
import Association from '../components/association.js';

function Contact() {
    const [loading, setLoading] = useState(false);

    if(loading){
        return <Progress/>;
    }else{
        return(
            <div className="about-content">
                <DefaultHeader img={img} heading="Contact Us"/>

                <div className="container mt-5">
                    <div className="row justify-content-center">
                        <h1 className='text-center'>Contact Us</h1>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className='col-md-8'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                            <p>Contact us for further information.</p>
                            <p><strong>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</strong></p>
                            <p><strong>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</strong></p>
                            <p><strong>Ph- <a href="tel:+910000000000" target="_blank">+91 0000000000</a>  | <a href="tel:+910000000000" target="_blank">+91 0000000000</a></strong></p>
                            <p><strong>What's App- <a href="https://wa.me/+910000000000" target="_blank">+91 0000000000</a></strong></p>
                            <p><strong>Email- <a href="#"> xxxxxxxxxxxxxxxxxxxxxxxxx</a>, <a href="#"> xxxxxxxxxxxxxxxxxxxxxxxxx</a></strong></p>
                            <p><strong>Website- <a href="https://htultrasound.com">https://htultrasound.com</a></strong></p>
                            <p><strong>Office Hours- </strong>10 AM-6.30 PM (Mon-Fri)</p>
                            <p><strong className="no-visible">Office Hours- </strong>10 AM-2 PM (Sat), Sunday Closed</p>
                        </div>
                        <div className='col-md-4'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14010.760057309688!2d77.22260516602377!3d28.609074898776033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2db961be393%3A0xf6c7ef5ee6dd10ae!2sIndia%20Gate%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1737443915370!5m2!1sen!2sin" width="100%" height="450" style={{border:1}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
                <Association/>
            </div>
        )
    }
}

export default Contact;